import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { CorporateActionsService } from './corporate-actions.service'

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  constructor(
    private readonly httpClient: HttpClient,
    public corporateActionsService: CorporateActionsService,
  ) {}

  /**
   * Return a map of CUSIPs to security IDs
   */
  getSecurityIdsBulk(cusips: string[]): Observable<Map<string, number>> {
    const idsByCusip: Map<string, number> = new Map<string, number>()

    if (!cusips || cusips.length == 0) {
      return of(idsByCusip)
    }

    return this.corporateActionsService.getSecurityCandidates(cusips).pipe(
      map(response => {
        response.forEach(result => {
          idsByCusip.set(result.term, result.securityId)
        })
        return idsByCusip
      }),
    )
  }
}
